import { ConfigEnvironmentVariableLinksResponseInterface } from '@types';

export type AppEnvironmentState = {
  configVariables: ConfigEnvironmentVariableLinksResponseInterface;
};

export const appEnvironmentInitialState: AppEnvironmentState = {
  configVariables: null,
};
